import { createAction } from 'redux-actions';

import { wrapFetch } from './endpoint';

export const getActivities = createAction('FETCH_ACTIVITIES', async (lan, hotel) => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/activity`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const activities = data.map(activity => ({
		id: activity.id,
		title: activity.title,
		label: activity.type,
		content: activity.intro,
		image: activity.pic,
		thumbnail: activity.pic_thumbnail,
		relationLink: activity.relation_link,
		joinLink: activity.join_link,
	}));

	return { activities };
});



// WEBPACK FOOTER //
// ./src/actions/activity.js